import { render, staticRenderFns } from "./incidents-origins-modal.vue?vue&type=template&id=0672cf12&"
import script from "./incidents-origins-modal.ts?vue&type=script&lang=ts&"
export * from "./incidents-origins-modal.ts?vue&type=script&lang=ts&"
import style0 from "./incidents-origins-modal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports